import React, { createElement, Component } from 'react'
import PropTypes from 'prop-types'
import isPromise from '@insight/toolkit-utils/lib/types/basic/isPromise'

import { FIELD_COMPONENTS } from '../Components/componentMap'
import ComponentDecorator from '../Components/ComponentDecorator'
import renderComponent from '../renderComponent'

const DEFAULT_ERRORS = []

export default class UnconnectedField extends Component {
	state = {
		errors: DEFAULT_ERRORS
	}

	setError = value => {
		if (!value) {
			if (!this.state.errors.length > 0) {
				return
			}
			this.setState({ errors: DEFAULT_ERRORS })
		} else {
			this.setState({ errors: [value] })
		}

		if (this.props.handleError) {
			// TODO: Only pass specfic props. But this is a temp holdover for unconnected field
			// until form refactor is done
			this.props.handleError(value, this.props)
		}
	}

	validate = value => {
		const { name, validate } = this.props
		const errorsOrPromise = validate(value)
		if (isPromise(errorsOrPromise)) {
			errorsOrPromise.then(
				() => this.setError(undefined),
				error => this.setError(error)
			)
		} else {
			this.setError(errorsOrPromise)
		}
	}

	onBlur = e => {
		const { format, formatOnBlur, handleBlur, name, validate, validateOnBlur } = this.props
		let ev = e
		if (format && formatOnBlur) {
			ev = { ...e, target: {
				...e.target,
				value: format(e.target.value, name)
			}}
		}
		handleBlur && handleBlur(ev)
		if (validate && validateOnBlur) {
			this.validate(ev.target.value)
		}
	}

	onChange = e => {
		const { handleChange, name, parse, validate, validateOnChange } = this.props
		let ev = e
		if (parse) {
			ev = { ...e, target: {
				...e.target,
				value: (parse ? parse(e.target.value, name) : e.target.value)
			}}
		}
		handleChange && handleChange(ev)
		if (validate && validateOnChange) {
			this.validate(ev.target.value)
		}
	}

  componentDidUpdate(prevProps) {
    const { value: prevValue } = prevProps
    const { value, validate, validateOnChange } = this.props
    if (prevValue !== value && validate && validateOnChange) {
      this.validate(value)
    }
  }

	render() {
		const {
			component,
			children,
			fieldComponent,
			format,
			formatOnBlur,
			handleBlur,
			handleChange,
			parse,
			name,
			validate,
			validateOnBlur,
			value,
			...rest
		} = this.props

		const { errors } = this.state
		const fieldProps = {
			errors,
			name,
			onBlur: this.onBlur,
			onChange: this.onChange,
			value,
			...rest
		}

		if (typeof children === 'function') {
			return children({ fieldProps })
		}
		if (typeof component === 'string') {
			return createElement(component, { ...fieldProps, children })
		}
		if (typeof fieldComponent === 'string') {
			return <ComponentDecorator fieldComponent={fieldComponent} fieldProps={fieldProps} />
		}

		return renderComponent({ ...fieldProps, children, component }, `Field(${name})`)
	}
}

UnconnectedField.propTypes = {
	component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	children: PropTypes.func,
	fieldComponent: PropTypes.oneOf(FIELD_COMPONENTS),
	format: PropTypes.func,
	formatOnBlur: PropTypes.bool,
	handleBlur: PropTypes.func,
	handleChange: PropTypes.func,
	max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	name: PropTypes.string.isRequired,
	parse: PropTypes.func,
	showCounter: PropTypes.bool,
	validate: PropTypes.func,
	validateOnBlur: PropTypes.bool,
	validateOnChange: PropTypes.bool,
	value: PropTypes.string
}
